import type {ReactNode} from 'react'
import {Icon} from 'components/elements/Icon' // Global import fucks up webpack
import {cn} from 'utils'
import type {
  DropdownProps,
  DropdownPropsTargetProps,
} from '../utils/Dropdown/Dropdown'
import {Dropdown} from '../utils/Dropdown/Dropdown'

export interface DropdownMenuProps
  extends Omit<DropdownProps, 'fitContentWidth' | 'target'> {
  target: (props: Omit<DropdownPropsTargetProps, 'ref'>) => ReactNode
  big?: boolean
}

export const DropdownMenu = ({
  target,
  content,
  className,
  big,
  placement = 'bottom',
}: DropdownMenuProps): ReactNode => {
  return (
    <Dropdown
      placement={placement}
      className={className}
      target={({ref, opened, open, close}) => (
        <div
          className={cn(
            'group/dropdownMenuTarget',
            'grid grid-cols-[1fr_16px] gap-x-2.5 items-center px-2.5 border rounded text-primaryTextColor',
            'hover:border-inputBorderColorHover hover:shadow-inputHoverBoxShadow hover:text-pictonBlue',
            'focus:border-inputBorderColorFocus focus:shadow-inputFocusBoxShadow',
            'active:border-inputBorderColorActive active:shadow-inputActiveBoxShadow',
            opened &&
              'border-inputBorderColorActive shadow-inputActiveBoxShadow text-pictonBlue bg-springWood',
            'transition-all cursor-pointer',
            'h-7.5 text-catSize',
            big && 'h-9 text-dogSize'
          )}
          onClick={() => (opened ? close() : open())}
          ref={ref}
        >
          <div>{target({opened, open, close})}</div>
          <div
            className={cn(
              'h-4 text-scarpaFlow transition-colors',
              'group-hover/dropdownMenuTarget:text-pictonBlue',
              'group-focus/dropdownMenuTarget:text-pictonBlue',
              'group-active/dropdownMenuTarget:text-pictonBlue',
              opened && 'text-pictonBlue'
            )}
          >
            <Icon icon='chevron-down' size='16' />
          </div>
        </div>
      )}
      content={(props) => content(props)}
      fitContentWidth
    />
  )
}
